import React from "react";
import { useTranslation } from "react-i18next";

import { PageState } from "@/components/common/PageState";
import { Button } from "@/components/ui/button";
import { useAdminImpersonation } from "@/hooks/useAdminImpersonation";
import { useLogout } from "@/hooks/useLogout";

export const ProfileUnavailableState: React.FC = () => {
  const { t } = useTranslation();
  const { handleLogout } = useLogout();
  const { exitImpersonation, isImpersonating } = useAdminImpersonation();
  const signOutLabel = isImpersonating
    ? t("layout.userMenu.exitImpersonation")
    : t("layout.userMenu.signOut");
  const handleAuthAction = isImpersonating ? exitImpersonation : handleLogout;

  return (
    <PageState tone="error" text={t("layout.profileUnavailable.description")}>
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          void handleAuthAction();
        }}
      >
        {signOutLabel}
      </Button>
    </PageState>
  );
};
